/* ErrorState.tsx generated by @compiled/babel-plugin v0.26.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, Stack, xcss } from '@atlaskit/primitives';
import React from 'react';
import ErrorIcon from '../../assets/ErrorIcon.svg';
const wrapperStyles = xcss({
  paddingTop: 'space.400',
  paddingBottom: 'space.600'
});
const loadingTextStyles = xcss({
  fontSize: '1rem',
  fontWeight: 600,
  textAlign: 'center'
});
export const ErrorState = () => /*#__PURE__*/React.createElement(Stack, {
  alignBlock: "center",
  alignInline: "center",
  space: "space.200",
  xcss: wrapperStyles
}, /*#__PURE__*/React.createElement("img", {
  src: ErrorIcon,
  alt: "",
  width: "120px"
}), /*#__PURE__*/React.createElement(Box, {
  xcss: loadingTextStyles,
  paddingInline: "space.400"
}, "We're having trouble loading, refresh to try again."));